import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HikingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hiking"}/>
}
